var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolC2PaCheckVerify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 17.5006C29.3333 21.3355 26.7635 24.5403 23.3333 25.3196M11.5556 14.511C10.9404 14.0786 10.2408 13.7684 9.48822 13.6132C9.13 13.5394 8.75978 13.5006 8.38095 13.5006C5.22504 13.5006 2.66667 16.1869 2.66667 19.5006C2.66667 22.8144 5.22504 25.5007 8.38095 25.5007M9.48822 13.6132C9.18275 12.7475 9.01587 11.8112 9.01587 10.834C9.01587 6.4157 12.427 2.83398 16.6349 2.83398C20.5545 2.83398 23.7828 5.94174 24.2068 9.93854M19.1747 9.95587C19.9689 9.66106 20.8237 9.50065 21.7143 9.50065C22.5872 9.50065 23.4257 9.65478 24.2068 9.93854M24.2068 9.93854C25.1175 10.2694 25.9497 10.7765 26.6667 11.421",
    stroke: "#1C274C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 24.084C11.3333 22.0805 11.3333 21.0788 11.9191 20.4563C12.5049 19.834 13.4477 19.834 15.3333 19.834H16.6667C18.5523 19.834 19.4951 19.834 20.0809 20.4563C20.6667 21.0788 20.6667 22.0805 20.6667 24.084V26.9173C20.6667 28.9208 20.6667 29.9225 20.0809 30.545C19.4951 31.1673 18.5523 31.1673 16.6667 31.1673H15.3333C13.4477 31.1673 12.5049 31.1673 11.9191 30.545C11.3333 29.9225 11.3333 28.9208 11.3333 26.9173V24.084Z",
    stroke: "#1C274C",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 25.5H17.3333",
    stroke: "#1C274C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolC2PaCheckVerify);
export default __webpack_public_path__ + "static/media/sol-c2pa-check-verify.9c799f15cbf1df0e49a9ab877ae6ba46.svg";
export { ForwardRef as ReactComponent };